import React, { useState, useEffect, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import 'react-times/css/classic/default.css';
import Images from 'assets/images/imageData';
import "./assesment.css";
import TableSection from 'components/sales/tableSection/tableSection';

const MasterAssesmentHistory = ({
    match,
    history,
    getMasterAssessmentHistory,
    testHistory
}) => { 
    const { id } = useParams();
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [listData, setListData] = useState();
    const [roleId, setRoleId] = useState();

    const headers = [
      'Level',
      'Total Question',
      'Total Attempted',
      'Total Correct',
      'Score',
      'Status',
      'Submitted By'
    ];

    useEffect(() => {
      const tableData = [
          'level',
          'total_questions',
          'total_attempted',
          'total_correct',
          'marks_percentage',
          'isCleared',
          'submitted_by'
      ];
      //console.log(testHistory);
      if (testHistory && testHistory?.data && testHistory?.data.length > 0) {
          const data = testHistory.data.map((element) =>
              Object.assign(
                  {},
                  ...tableData.map((key) => (
                    (key === 'isCleared' && element['isCleared'] === 0) ? 
                    {[key]: 'Not Cleared'} : (key === 'isCleared' && element['isCleared'] === 1) ? 
                    {[key]: 'Cleared'} : (key === 'marks_percentage') ? {[key]: element[key] + '%'}
                    :{ [key]: element[key] })
                  )
              )
          );  
          data && setListData(data);
          setPageCount(Math.ceil(testHistory.total / testHistory.per_page));
      }
    }, [testHistory]);
    //console.log('data ' + JSON.stringify(testHistory));
    console.log('PAGE::MASTER ASSESMENT HISTORY'); 

    useEffect(() => {
       if(getMasterAssessmentHistory) {
        (async () => {
          setIsLoading(true);
          const res = await getMasterAssessmentHistory();
          if(res) {
            console.log(res);
          }
          setIsLoading(false);
        })();  
       }
    },[getMasterAssessmentHistory]);

    const onPageChange = async (val) => {
      setIsLoading(true);
      await getMasterAssessmentHistory(val.selected + 1);
      setIsLoading(false);
    };

    return(
        <Layout
          title={`Results`}
          isGoback={true}
          isLoading={isLoading}
          linkUrl={`${baseUrl}/training-levels`}
        >
        <div className="container-fluid">
         <div className="card">
          <div className='card-header'>{localization.assesmentResult}</div>
          <div className="card-body">
          <TableSection
              data={listData}
              isId={false}
              isMngId={false}
              headers={headers}
              pageCount={pageCount}
              onPageChange={onPageChange}
              srNo={testHistory?.data?.from}
          />
          </div>
         </div>
        </div> 
        </Layout>
    );

};
export default MasterAssesmentHistory;